import { Container } from "react-bootstrap";
import { RouteProps } from "react-router";
import Content from "Types/Content";

const Dependencias: React.FC<RouteProps> = () => {
  return (
    <Container className='pt-3'>
      <h1>
        <a href='https://www.atlassian.com/es/git/tutorials/comparing-workflows/Dependencias-workflow'>
          Dependencias
        </a>
      </h1>
      <p className='text-justify'>
        Hay que ser muy precavido a la hora de agregar librerías a un proyecto.
        Estas no solo agregar peso, si no que también agregan puntos de falla. A
        medida que nuestro programa dependa de más cosas, más posibilidades hay
        de que falle. Por eso existen preguntas imporantes que hay que hacer
        siempre antes de agregar una librería:
      </p>
      <h2>¿Hay una buena razón para no hacerlo yo?</h2>
      <p>
        Muchas veces agregamos una librería para componentes con alguna lógica
        particular que no sale de algo que no se pueda hacer con un par de
        líneas en el framework en el que trabajamos. Deslizadores, Carruseles,
        Tablas interactivas, etc. Todos estos son solo componentes con cierta
        lógica que muchas veces es mejor hacerlos a medida para que se ajusten
        apropiadamente a nuestro caso de uso. Y no tener algun componente super
        genérico que haga 18 mil cosas y solo usemos 3.
      </p>
      <h2>¿Cuanta gente lo usa?</h2>
      <p>
        Puede que nuestro programa necesite existir por muchos años, y si dentro
        de unos meses esa librería ya no tiene más soporte, entonces tenemos un{" "}
        <strong>gran</strong> problema. Ver la cantidad de proyectos que depende
        de esa librería es una buena manera de estimar el nivel de soporte que
        tiene. React es una librería con más de 10 millones de descargas
        semanales según{" "}
        <a href='https://www.npmjs.com/package/react'>npmjs.com</a> Dudo mucho
        que pierda soporte pronto. Pero capaz la librería que hizo José hace 2
        años y que tiene menos de 30 descargas semanales no viva mucho más...
      </p>
      <h2>¿Está bien documentado?</h2>
      <p>
        La última pregunta, y quizá la más importante, es si el proyecto está
        propiamente documentado. Si la librería que queremos usar no tiene buena
        documentación, entonces <strong>no es buena idea usarla</strong>. No
        importa que haya videos en youtube de gente usandola. Hay que utilizar
        las fuentes oficiales siempre que sea posible.
      </p>
    </Container>
  );
};

export default new Content({
  Component: Dependencias,
  title: "Dependencias",
  route: "depenencias",
  tags: [
    "código",
    "dependencias",
    "programador",
    "programación",
    "procesos",
    "buenas",
    "practicas",
    "modulos",
    "modular",
    "modularización"
  ]
});
